<script>
import CourseActivitiesComponent from '../../features/boxes/CourseActivitiesComponent';
import ModalCoursePublicActivityView from '../modals/ModalCoursePublicActivityView';

export default {
  components: {
    'modal-course-public-activity-view': ModalCoursePublicActivityView,
  },
  extends: CourseActivitiesComponent,
};
</script>

<template>
  <div class="course_activities_list">
    <div
      v-for="(activity, activityIndex) in orderActivities(courseSubject.courseSubjectActivities)"
      :key="activityIndex"
      class="activity_item_row"
    >
      <div class="activity_item_left">
        <span class="activity_type_icon_box">
          <i :class="getActivityIcon(activity)" />
        </span>
        <div class="activity_item_texts">
          <span class="activity_title">{{ activity.title }}</span>
          <span
            v-if="activity.duration"
            class="activity_duration_tag"
          >
            <i class="uil uil-clock" /> {{ activity.getDuration() }}
          </span>
        </div>
      </div>
      <div class="activity_item_right">
        <el-button
          v-if="activity.isPublic"
          type="primary"
          size="small"
          class="activity_preview_btn"
          @click="onShowPublicActivity(activity)"
        >
          <i class="uil uil-eye" /> Vista previa
        </el-button>
      </div>
    </div>

    <modal-course-public-activity-view
      v-if="modalItemCoursePublicActivity.isVisible"
      :conf="modalItemCoursePublicActivity"
      :form-data="activityPreview"
    />
  </div>
</template>
